<template>
  <div>
    <div class="tableData">
      <span>团财保全单共有<span class="num">{{ total }}笔</span></span>
      <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" v-if="row.status != '-99'" @click="detail(row)">详情</span>
          <span v-else>-</span>
          <span v-if="$units.pointAction('order_40_2_2')&&row.billFiles && row.status == '50'" class="table-btn" @click="exportBillFiles(row)">下载批单</span>
          <span v-if="$units.pointAction('order_40_2_3')&&(row.status == '-15' || row.status == '0' || row.status == '20')" class="table-btn" @click="reset(row)">撤销</span>
        </template>
      </Table>
    </div>
    <Page :total="total" :current="pageNum" :page-size="5" show-total @on-change="getList"
      style="text-align: center" />
    </div>
  </div>
</template>

<script>
import { pageTool,common } from '@/api/mixins';
import { config } from './peservation.config.js';
export default {
  mixins: [pageTool, common,config],
  data(){
    return{
      pageSize: 5,
    }
  },
  created(){
    this.tableData = [];
    this.getColumns();
    this.initListAjax('/buz/endorsement/read/list');
  },
  methods:{
    setListParams(params){
        params.pageSize = 5;
        params.statusList = ['0','20']
    },
    // 详情
    detail(row) {
      // 桐心企业保
      if(row.policyType == 1 || row.dockChannel == 3){
        this.$http({
          url: `/buz/endorsement/detail?id=${row.id}`,
          type: "GET",
        }).then((res) => {
          window.open(res.data, "_blank");
        })
      }else{
        this.openPageTabTags('/orderManage/group/peservation/detail', { id: row.id, policyNo: row.policyNo,workName:'workName' });
      }      
    },
    reset(row) {
      this.$notice.inquiry('请确认是否要撤销？').then(async () => {
        this.$http({
          url: `/buz/endorsement/cancel`,
          type: "GET",
          data: {
            businessNo: row.businessNo
          },
          apiPermissionCode:'order_40_2_3'
        }).then((res) => {
          this.$Message.success("操作成功");
          this.getList()
        })
      })
    },
    exportBillFiles(row) {
      window.open(row.billFiles);
    },
  }
}


</script>

<style lang="scss" scoped>
.tableData{
  padding: 15px 20px 20px 20px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 18px;
  color: #727C8E;
  .num{
    color: #FF5F00;
  }
  .table-box{
    margin-top: 10px;
  }
}
.table-btn{
  border-right: 1px solid #CED1D5;
  margin: 0;
  padding: 0 6px;
  line-height: 13px;
  &:last-child{
    border:0;
  }
}
</style>